export enum SurgicalOrderSituation {
  GREEN = 'GREEN',
  ORANGE = 'ORANGE',
  RED = 'RED'
}

export enum SurgicalOrderSituationTranslated {
  GREEN = 'No prazo',
  ORANGE = 'Crítico',
  RED = 'Atrasado'
}
